import imageCompression from 'browser-image-compression';

export const compressImages = async (images) => {
    const compressedImages = [];
    const options = {
      maxSizeMB: 1,            // (default: Number.POSITIVE_INFINITY)
      useWebWorker: false,     // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
      maxIteration: 10         // optional, max number of iteration to compress the image (default: 10)
    };

    for(const image of images){
      if (image.size > 1000000) {  // 1 MB
        const compressedBlob = await imageCompression(image, options);
        const compressedBlobWithExif = await copyExif(image, compressedBlob);
        const currentTime = new Date();
        const file = new File([compressedBlobWithExif], image.name, {lastModified: currentTime, type: "image/jpeg"});
        compressedImages.push(file);
      } else {
        // skip compression for smaller files
        compressedImages.push(image);
      }
    }
    return compressedImages;
}


const copyExif = async (src, dest) => {
  const exif = await retrieveExif(src);
  let blob = new Blob([dest.slice(0, 2), exif, dest.slice(2)], {
    type: "image/jpeg",
    name: dest.name
  });
  blob.name = dest.name;
  return blob;
}

const SOS = 0xffda;
const APP1 = 0xffe1;
const EXIF = 0x45786966;

const retrieveExif = blob => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", ({ target: { result: buffer } }) => {
      const view = new DataView(buffer);
      let offset = 0;
      if (view.getUint16(offset) !== 0xffd8)
        return reject("not a valid jpeg");
      offset += 2;

      while (true) {
        const marker = view.getUint16(offset);
        if (marker === SOS) break;
        const size = view.getUint16(offset + 2);
        if (marker === APP1 && view.getUint32(offset + 4) === EXIF)
          return resolve(blob.slice(offset, offset + 2 + size));
        offset += 2 + size;
      }
      return resolve(new Blob());
    });
    reader.readAsArrayBuffer(blob);
  });
}
